import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';

/*BootstrapTable and table Related*/
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableRow';

/*Loader */
import FadeIn from 'react-fade-in';

/*Styles*/
import './PlayerOpenBets.css';
import { dateTimeReportFormatter2 } from '../../fomatters/DateFormatter';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Select, MenuItem } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  button: {
    display: 'block',
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function OpenBets(props) {
  const classes = useStyles();
  const [openBets, setOpenBets] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalRisk, setTotalRisk] = useState(0);
  const [totalWin, setTotalWin] = useState(0);
  const [voidReasons, setVoidReasons] = useState([])
  const [openModal, setOpenModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [selectedRisk, setSelectedRisk] = useState(0);
  const [selectedRow, setSelectedRow] = useState();

  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );

  useEffect(() => {
    fetchOpenBets();
  }, [props.Player.idPlayer]);

  const fetchOpenBets = () => {
    let idPlayer = props.Player.idPlayer;
    const url =
      process.env.REACT_APP_API2_URL +
      '/Player/GetPlayerOpenBets?idPlayer=' +
      idPlayer;

    axios({
      method: 'post',
      url: url,
    }).then((response) => {
      const groupedBets = response.data.reduce((acc, bet) => {
        const ticket = acc.find((item) => item.TicketNumber === bet.ticketNumber);
        if (ticket) {
          ticket.Bets.push(bet);
        } else {
          acc.push({
            TicketNumber: bet.ticketNumber,
            HeaderDescription: bet.headerDescription,
            RiskAmount: bet.riskAmount,
            WinAmount: bet.winAmount,
            PlacedDate: bet.placedDate,
            IdSport: bet.idSport,
            Bets: [bet],
          });
        }
        return acc;
      }, []);
      console.log(groupedBets)
      setOpenBets(groupedBets);

      setIsLoading(false);

      let totalRiskAmount = groupedBets.reduce((acc, bet) => acc + bet.RiskAmount, 0);
      let totalWinAmount = groupedBets.reduce((acc, bet) => {
        if (bet.HeaderDescription.includes("If Win")) {
          return acc + bet.Bets.reduce((sum, b) => sum + b.winAmount, 0);
        } else {
          return acc + bet.WinAmount;
        }
      }, 0);

      setTotalRisk(totalRiskAmount);
      setTotalWin(totalWinAmount);
    });
  }

  const gameDateFormatter = (cell, row) => {
    return (
      <>
        <div>Ticket #{row.TicketNumber}</div>
        <ul>
          {row.Bets.map((bet, index) => (
            <li className="nospace !text-[12px]" key={index}>{bet.gameDateTime ? bet.gameDateTime?.replace("T", " ") : bet.placedDate?.replace("T", " ").replace(/\.\d+$/, "")}</li>
          ))}
        </ul>
      </>
    );
  };

  const riskWinFormatter = (cell, row) => {
    return (
      <>
        {
          row.HeaderDescription.includes("If Win")
          ?
          <>
            <div className='h-[16px]'></div>
            {row.Bets.map((bet, index) => (
              <div key={index}>{bet.riskAmount}/{bet.winAmount}</div>
            ))}
          </>
          : <div>{row.RiskAmount}/{row.WinAmount}</div>
        }
      </>
    );
  };

  const typeDescriptionFormatter = (cell, row) => {
    return (
      <>
        <div>{row.HeaderDescription}</div>
        <ul>
          {(row.Bets || []).map((bet, index) => (
            <li className="nospace !text-[12px]" key={index}>{bet.detailDescription}</li>
          ))}
        </ul>
      </>
    );
  };

  const idSportFormatter = (cell, row) => {
    if (!row.Bets || row.Bets.length === 0) return null;

    const allSameIdSport = row.Bets.every(
      (bet) => bet.idSport === row.Bets[0].idSport
    );

    return (
      <>
        {allSameIdSport ? (
          <div className='!text-[12px]'>{row.Bets[0].idSport}</div>
        ) : (
          <ul>
            <li className='h-[16px]'></li>
            {row.Bets.map((bet, index) => (
              <li className='!text-[12px]' key={index}>{bet.idSport}</li>
            ))}
          </ul>
        )}
      </>
    );
  };

  const userNameFormatter = (cell, row) => {
    const allSameUser = row.Bets.every(
      (bet) => bet.loginName === row.Bets[0].loginName
    );
    return (
      <>
        {allSameUser ? (
          <div className='!text-[12px]'>{row.Bets[0].loginName}</div>
        ) : (
          <ul>
            <li className='h-[16px]'></li>
            {row.Bets.map((bet, index) => (
              <li className='!text-[12px]' key={index}>{bet.loginName}</li>
            ))}
          </ul>
        )}
      </>
    );
  };

  const options = {
    beforeShowError: (type, msg) => {
      this.setState({ errType: type, errMsg: msg });
    },
  };

  const isExpandableRow = (row) => {
    return true;
  };

  class BSTable extends React.Component {
    render() {
      if (this.props.data) {
        return (
          <Table className="table-open-bets">
            <TableCell>
              <p>
                <b> {this.props.data.headerDescription}</b>
                <br />
                {this.props.data.idWager}
                <br />
                <small>
                  <b>Event Date: {this.props.data.gameDateTime} </b>
                </small>
              </p>
            </TableCell>
            <TableCell>
              <p>
                <b> {this.props.data.loginName} </b>
                <br />
                {this.props.data.ip}
                <br />
                <small>
                  <b>Placed Date: {this.props.data.placedDate} </b>
                </small>
              </p>
            </TableCell>
            <TableCell colSpan="2">
              <p>
                <b>Ticket Description</b>
              </p>
              <li key={this.props.data.idWager}>
                {this.props.data.detailDescription}{' '}
              </li>

              {this.props.data.Leg &&
                this.props.data.Leg.map(function (item, i) {
                  return <li key={i}>{item.detailDescription} </li>;
                })}
              <br />
              <hr></hr>
              <p style={{ textAlign: 'center' }}>
                <b>Risk/Win : </b>
                {this.props.data.riskAmount}/ {this.props.data.winAmount}{' '}
              </p>
              <hr></hr>
            </TableCell>
          </Table>
        );
      } else {
        return <p>?</p>;
      }
    }
  }

  const resultFormatter = (cell, row) => {
    return (
      <>
        <div className='h-[16px]'></div>
        <ul>
          {row.Bets.map((bet, index) => (
            <li className='!text-[12px]' key={index}>
              {bet.detailResult === 255
                ? "PEND"
                : bet.detailResult === 1
                  ? "WIN"
                  : bet.detailResult === 2
                    ? "PUSH"
                    : bet.detailResult === 0
                      ? "LOSE"
                      : bet.detailResult === 3
                        ? "NO BET"
                        : bet.detailResult == 6
                          ? "N/A CANCEL"
                          : bet.detailResult === 5
                            ? "N/A PITCHER"
                            : bet.detailResult === 7
                              ? "N/A SHORT"
                              : " "}
            </li>
          ))}
        </ul>
      </>
    );
  };

  const expandComponent = (row) => {
    return <BSTable data={row} />;
  };

  const fetchVoidReasons = () => {
    const url = process.env.REACT_APP_API2_URL + "/Wager/VoidReason_GetList";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setVoidReasons(data)
      });
  }

  const deleteBet = () => {
    let req = {
      IdWager: selectedTicket,
      RiskAmount: selectedRisk,
      IdUser: userInfo.UserId,
      Chart: 1,
      IdVoidReason: selectedReason,
      IfWager: selectedRow.Bets[0].ifBetWagerType === 3 ? 1 : selectedRow.Bets[0].ifBetWagerType === 7 ? 2 : 0,
    }
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Wager/DeleteBet",
      data: req
    }).then((response) => {
      if (response.data == "ok") {
        toast.success("Bet deleted succesfully.");
        fetchOpenBets();
      } else {
        toast.error(response.data);
      }
      console.log("response", response);
    });
  }

  useEffect(() => {
    fetchVoidReasons();
  }, [])

  const handleOpenModal = (row) => {
    setSelectedTicket(row.TicketNumber);
    setSelectedRisk(row.RiskAmount);
    setSelectedRow(row);
    console.log(row);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedReason("");
    setSelectedTicket(null);
  };

  const handleConfirm = () => {
    deleteBet();
    handleCloseModal();
  };

  const renderDeleteIcon = (cell, row) => (
    <DeleteIcon
      style={{ cursor: "pointer", color: "#db0000", width: "20px" }}
      onClick={() => handleOpenModal(row)}
    />
  );

  return (
    <React.Fragment>
      <div className="main-div">
        {isLoading ? (
          <FadeIn>
            <div className="d-flex justify-content-center align-items-center">
              <Loader height={360} width={360} />
            </div>
          </FadeIn>
        ) : (
          <>
            <div className="table-responsive table-wrapper-scroll-y my-custom-scrollbar table-hist">
              <BootstrapTable
                className="text-xs "
                data={openBets}
                options={options}
              >
                <TableHeaderColumn
                  dataField="PlacedDate"
                  dataFormat={dateTimeReportFormatter2}
                  width="120"
                >
                  Placed
                </TableHeaderColumn>

                <TableHeaderColumn
                  dataField="TicketNumberGameDateTime"
                  dataFormat={gameDateFormatter}
                  width="160"
                  columnClassName="custom-padding nospace"
                >
                  Game Date
                </TableHeaderColumn>

                <TableHeaderColumn
                  dataField="IdSport"
                  width="50"
                  dataFormat={idSportFormatter}
                >
                </TableHeaderColumn>
                <TableHeaderColumn isKey={true} hidden dataField="TicketNumber">
                  TicketNumber
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="TypeDescription"
                  dataFormat={typeDescriptionFormatter}
                  width="350"
                  columnClassName="custom-padding nospace"
                >
                  Type/Description
                </TableHeaderColumn>
                <TableHeaderColumn
                  flex="1"
                  dataField="DetailResult"
                  dataFormat={resultFormatter}
                  width="90"
                >Status</TableHeaderColumn>
                <TableHeaderColumn width="130" dataField="RiskAmountWinAmount" dataFormat={riskWinFormatter}>
                  Risk/Win
                </TableHeaderColumn>
                <TableHeaderColumn width="80" dataField="LoginName" dataFormat={userNameFormatter}>
                  User
                </TableHeaderColumn>
                <TableHeaderColumn width="60" dataField="action" dataFormat={renderDeleteIcon}>
                </TableHeaderColumn>
              </BootstrapTable>

              {/* Modal */}
              <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="xs">
                <DialogTitle>Choose a reason</DialogTitle>
                <DialogContent>
                  <select
                    value={selectedReason}
                    onChange={(e) => setSelectedReason(e.target.value)}
                    style={{ width: "100%", padding: "8px", fontSize: "14px" }}
                    className='selectInp'
                  >
                    <option value="" disabled>Select a reason</option>
                    {voidReasons.map((reason) => (
                      <option key={reason.IdVoidReason} value={reason.idVoidReason}>
                        {reason.voidReason}
                      </option>
                    ))}
                  </select>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseModal} color="secondary">
                    Cancel
                  </Button>
                  <Button onClick={handleConfirm} color="primary" disabled={!selectedReason}>
                    OK
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
            <div className="summary">
              <span>{openBets.length} wager(s)</span>
              <span>At Risk ${totalRisk}</span>
              <span>To Win ${totalWin}</span>
            </div>
          </>
        )}
      </div>
    </React.Fragment>
  );
}
